import {Component, OnInit} from '@angular/core';
import {IconService} from './core/services/icon.service';

@Component({
  selector: 'brn-root',
  template: '<brn-main-layout></brn-main-layout>',
})
export class AppComponent implements OnInit {
  constructor(private iconService: IconService) {
  }

  ngOnInit(): void {
    const documentStyle = document.body.style;
    documentStyle.setProperty('--tangaroa', 'red');
  }

}
